import type { Partner, Product, UserType } from '../../enums'
import type { PagedQuery } from '../Shared/PagedQuery'
import type { UserRole } from './UserRole'

export type User = {
  userId?: string
  ouId?: number
  userName?: string
  name?: string
  surname?: string
  email?: string
  phone?: string
  ouName?: string
  ouDescription?: string
}

export type LoggedUser = {
  logged: boolean
  id?: string
  type?: UserType
  firstName?: string
  lastName?: string
  ouId?: number
  userFullName?: string
  insuringAllowed?: number
  email?: string
  phoneNumber?: string
  userName?: string
  clientKey?: keyof typeof Partner
  enableSwithToOldApp?: boolean
  propertyRights?: boolean
  vehicleRights?: boolean
  leasingRights?: boolean
  travelRights?: boolean
  vehicleExtraRights?: boolean
  fleetRights?: boolean
  liabilityRights?: boolean
  dailyPov?: boolean
  newDailyPov?: boolean
  enableContractReplacement?: boolean
  allowCreateInsuranceAsSomeoneElse?: boolean
  allowEditAppInfoMessages?: boolean
  allowExportContracts?: boolean
  buildDate?: string
  allowMultipleVariantSelection?: boolean
  cebiCat?: boolean
  cebiGlass?: boolean
  vinOnline?: boolean
  subaruInsuranceAllowed?: boolean
  mazdaInsuranceAllowed?: boolean
  kiaInsuranceAllowed?: boolean
  preferKoopOffers?: boolean
  isSupervisor?: boolean
  showOffersRating?: boolean
  allowDiscountsOverLimit?: boolean
  approveDiscountsOverLimit?: boolean
  enableAutorizacePpz?: boolean
  autorizacePpz?: PpzAutorization
  poleas?: Poleas
  collapsableBaseAddons?: boolean
  enableCloneOffer?: true
  enableRecalculateOffer?: true
  enableOfferXml?: true
  autoLogoffWarningTime?: number | null
  allowEditOrganizationStructure?: boolean
  allowDisplayOrganizationStructure?: boolean
  allowDisplayOrganization?: boolean
  adminCebiaRights?: boolean
  allowUploadInsuranceDocuments?: boolean
  availablePartners?: AvailablePartner[]
  enablePoleasEssox?: boolean
  showLicensePlate?: boolean
  allowGenerateKoopSalon?: boolean
  allowNews?: boolean
  roles?: UserRole[]
  rtpcRights?: boolean
  organizationName?: string
  mustChangePassword?: boolean
  ico?: string
  allowMoreThanOneMainOffers?: boolean
    enableContractMultipleInsurers?: boolean
    allowChangePriceTypeToValuation?: boolean
}

export interface AvailablePartner {
  id: number
  name: string
  enumKey: keyof typeof Partner
  logoUrl?: string
}

export interface AppInfoMessageDto {
  id: number
  dateCreatedMember?: Date | null
  dateModifiedMember?: string | null
  modifiedByIdMember: string
  createdByIdMember: string
  messageDate: string
  messageHeader: string
  messageText: string
  messageImportance: AppInfoMessageImportanceTypes
  messageShow: number
  insuranceCategoryType: Product
  read?: boolean | null
  type: string
}

export type AppInfoMessage = {
  id: number
  dateCreatedMember: Date
  messageDate?: Date
  messageImportance: AppInfoMessageImportanceTypes
  messageShow?: boolean
  read?: boolean
  messageHeader?: string
  messageText?: string
  insuranceCategoryType?: Product
  type?: string
  insurers?: AppInfoMessageInsurer[]
}

export const AppInfoMessageImportanceTypes = {
  Standard: 1,
  High: 2,
  Unavailability: 3,
} as const

export type AppInfoMessageImportanceTypes = typeof AppInfoMessageImportanceTypes[keyof typeof AppInfoMessageImportanceTypes];

export type AppInfoMessageInsurer = {
  insurerId: string
}

export interface AppInfoMessageFilter {
  unread?: boolean
  from?: Date
  to?: Date
  insurer?: number
  product?: Product
  priority?: number
  excludeId?: number
  shown?: boolean
}

export interface AppInfoMessagePagedQuery extends PagedQuery, AppInfoMessageFilter { }

export interface AresData {
  ic: string
  errorMessage: string
  dic: string
  nazev: string
  datumVzniku: string
  datumZaniku: string
  pravniFormaKod: string
  pravniFormaNazev: string
  adresaId: string
  adresaObec: string
  adresaCastObce: string
  adresaMestskaCast: string
  adresaUlice: string
  adresaCislo: string
  adresaPsc: string
  adresaStat: string
  adresaDorucovaciUliceCislo: string
  adresaDorucovaciPscObec: string
  priznakySubjektu: string
  pocetZamestnancu: string
  isValidIc: boolean
  isObchodniRejstrik: boolean
  isRegistrEkonomickychSubjektu: boolean
  isZivnostenskyRejstrik: boolean
  isPlatceDph: boolean
  isPlatceSpotrebniDan: boolean
  isRegistrUpadciKonkurz: boolean
  isRegistrUpadciVyrovnani: boolean
  isRegistrAris: boolean
  isRegistrStran: boolean
  isSpolek: boolean
  isInsolvence: boolean
}

export interface OkKlientSpec {
  belongsToOkKlient: boolean
}

export interface PpzAutorization {
  hasAuthorization: boolean
  authorizedFrom?: Date
  authorizedTo?: Date
}

export interface Poleas {
  poleasEnabled?: boolean
  enableImport?: boolean
  enableEdit?: boolean
}
